'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _quiverAssets = require('@surfline/quiver-assets');

var _quiverAssets2 = _interopRequireDefault(_quiverAssets);

var _CamTimeout = require('../CamTimeout');

var _CamTimeout2 = _interopRequireDefault(_CamTimeout);

var _CamUpsell = require('../CamUpsell');

var _CamUpsell2 = _interopRequireDefault(_CamUpsell);

var _CamNighttime = require('../CamNighttime');

var _CamNighttime2 = _interopRequireDefault(_CamNighttime);

var _CamAdBlock = require('../CamAdBlock');

var _CamAdBlock2 = _interopRequireDefault(_CamAdBlock);

var _CamRewind = require('../CamRewind');

var _CamRewind2 = _interopRequireDefault(_CamRewind);

var _CamRewindMessage = require('../CamRewindMessage');

var _CamRewindMessage2 = _interopRequireDefault(_CamRewindMessage);

var _CamError = require('../CamError');

var _CamError2 = _interopRequireDefault(_CamError);

var _AspectRatioContent = require('../AspectRatioContent');

var _AspectRatioContent2 = _interopRequireDefault(_AspectRatioContent);

var _camConfig = require('./camConfig');

var _CountDownTimer = require('../CountDownTimer');

var _CountDownTimer2 = _interopRequireDefault(_CountDownTimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CamPlayer = function (_Component) {
  (0, _inherits3.default)(CamPlayer, _Component);

  function CamPlayer(props) {
    (0, _classCallCheck3.default)(this, CamPlayer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CamPlayer.__proto__ || (0, _getPrototypeOf2.default)(CamPlayer)).call(this, props));

    _this.getStringFromParams = function (params) {
      return (0, _keys2.default)(params).map(function (key) {
        return key + '=' + params[key];
      }).join('&');
    };

    _this.getAdTag = function (width, height) {
      var adCount = _this.state.adCount;

      if (adCount > 5) return null; // Stop trying to render an ad after 5th failure
      if (adCount > 4) return _quiverAssets2.default + '/adtags/PreRoll_SLAdFreePrem_rincon_MVP_feb18.xml';

      var adTagOptions = (0, _extends3.default)({}, _camConfig.adTagConfig, _this.props.adTag, {
        url: encodeURIComponent(window.location.protocol + '//' + window.location.hostname),
        description_url: encodeURIComponent(window.location.href)
      });

      var customOptions = {
        spotid: _this.props.advertisingIds.spotId,
        subregionId: _this.props.advertisingIds.subregionId,
        viewtype: _this.props.viewType || 'SPOT',
        qaFlag: _this.props.qaFlag,
        embedUrl: window.location.href,
        usertype: _this.props.isPremium ? 'premium' : 'free',
        count: adCount,
        width: width,
        height: height
      };
      var customParams = encodeURIComponent(_this.getStringFromParams(customOptions));
      return 'https://pubads.g.doubleclick.net/gampad/ads?' + _this.getStringFromParams(adTagOptions) + '&cust_params=' + customParams;
    };

    _this.getHostedAdClassName = function () {
      var nighttime = _this.props.nighttime;

      return (0, _classnames2.default)({
        'quiver-cam-player__player__host-ad': true,
        'quiver-cam-player__player__host-ad--rewind-aware': nighttime
      });
    };

    _this.resumePlayer = function () {
      _this.setState({ showTimeout: false, isStreaming: true });
      _this.camPlayer.play();
    };

    _this.className = function () {
      return (0, _classnames2.default)({
        'quiver-cam-player': true,
        'quiver-cam-player--upsell': _this.state.showUpSell,
        'quiver-cam-player--timeout': _this.state.showTimeout
      });
    };

    _this.camPlayer = null;
    _this.adInterval = 30;
    _this.upsellDuration = 15; // Seconds
    _this.premiumTimeout = 600; // 10 minute premium timeout
    _this.camWidth = null;
    _this.state = {
      showTimeout: false,
      showUpSell: false,
      isStreaming: false,
      adCount: 1,
      networkError: {
        isDown: false,
        message: null
      }
    };
    return _this;
  }

  (0, _createClass3.default)(CamPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          adblock = _props.adblock,
          onDetectedAdBlock = _props.onDetectedAdBlock;

      if (adblock && onDetectedAdBlock) {
        this.props.onDetectedAdBlock();
      }
      this.setupPlayer();
    }

    // if a user navigates to a new spot, reset player state

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.camera && this.props.camera.streamUrl !== nextProps.camera.streamUrl) {
        this.setState({
          showTimeout: false,
          showUpSell: false,
          isStreaming: false,
          adCountdownTime: 0
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props2 = this.props,
          camera = _props2.camera,
          adblock = _props2.adblock,
          onDetectedAdBlock = _props2.onDetectedAdBlock,
          onToggleStreaming = _props2.onToggleStreaming;
      var isStreaming = this.state.isStreaming;

      if (camera && camera.streamUrl !== prevProps.camera.streamUrl) {
        this.setupPlayer();
      }
      if (!prevProps.adblock && adblock && onDetectedAdBlock) {
        this.props.onDetectedAdBlock();
      }
      if (onToggleStreaming && isStreaming !== prevState.isStreaming) {
        onToggleStreaming(isStreaming);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.camPlayer && this.camPlayer.remove) this.camPlayer.remove();
    }
  }, {
    key: 'setupPlayer',
    value: function setupPlayer() {
      var _this2 = this;

      if (window && window.jwplayer) {
        var _props3 = this.props,
            nighttime = _props3.nighttime,
            rewindClip = _props3.rewindClip,
            playerId = _props3.playerId,
            camera = _props3.camera,
            isPremium = _props3.isPremium,
            isPersistentCam = _props3.isPersistentCam,
            aspectRatio = _props3.aspectRatio,
            companionHandler = _props3.companionHandler;

        window.jwplayer.key = window.jwplayer.defaults.key;
        this.camPlayer = window.jwplayer(playerId);
        this.rewindClipError = false;

        if (!this.camPlayer.setup) return;

        var file = nighttime && rewindClip ? rewindClip : camera.streamUrl;
        var accessToken = _reactCookie2.default.load('access_token');
        if (accessToken) {
          file += '?accessToken=' + accessToken;
        }
        var withCredentials = file.indexOf('authorization') > -1;
        this.camPlayer.setup((0, _extends3.default)({
          file: file,
          type: file.indexOf('mp4') > -1 ? 'mp4' : 'hls',
          withCredentials: withCredentials,
          image: camera.stillUrl,
          aspectratio: aspectRatio
        }, (0, _camConfig.setupConfig)(isPremium || isPersistentCam)));

        if (nighttime && rewindClip) {
          this.camPlayer.on('error', function () {
            _this2.rewindClipError = true;
            _this2.camPlayer.load({
              file: camera.streamUrl,
              withCredentials: camera.streamUrl.indexOf('authorization') > -1,
              image: camera.stillUrl
            });
          });
        }

        // fires preRoll Ad.
        if (!isPremium && !this.rewindClipError) {
          this.camPlayer.on('beforePlay', function () {
            _this2.playAd();
            if (_this2.rewindClipError) _this2.rewindClipError = false;
          });
        }

        this.camPlayer.on('adTime', function (obj) {
          _this2.setState({ adCountdownTime: Math.round(obj.duration - obj.position) });
        });

        // executes adError waterfall.
        this.camPlayer.on('adError', function () {
          _this2.setState({ adCount: _this2.state.adCount += 1 });
          if (_this2.state.adCount <= 5) {
            _this2.playAd();
          } else {
            _this2.camPlayer.play(); // if an add fails to load more than 5 times, play the camera.
          }
        });

        this.camPlayer.on('error', function (err) {
          if (err.message === 'Cannot load M3U8: 404 Not Found') {
            _this2.setState({
              networkError: {
                isDown: true,
                message: 'This cam is currently experiencing an outage,\n                our Cam Team is looking into the issue.'
              }
            });
          }
        });

        // sends companion ad styles and html up to parent
        if (companionHandler) {
          this.camPlayer.on('adCompanions', function (event) {
            companionHandler(event.companions);
          });
        }

        // restarts the cam stream when ad finishes.
        this.camPlayer.on('adComplete', function () {
          return _this2.setState({ showTimeout: false, adCount: 1 });
        });
        // resets the adError waterfall count.
        this.camPlayer.on('play', function () {
          return _this2.setState({ isStreaming: true });
        });
        this.camPlayer.on('pause', function () {
          return _this2.setState({ isStreaming: false });
        });

        // coordinates mid roll ad chain
        var timeElapsed = 0;
        var currentTime = 0;
        this.camPlayer.on('time', function (event) {
          var playerPosition = Math.round(event.position);
          /*
            Because this Event is fired multiple times (<=10) a second,
            this conditional is required for tracking total seconds played.
          */
          if (playerPosition !== currentTime) {
            currentTime = playerPosition;
            timeElapsed += 1;
          }

          if (!isPremium && timeElapsed === _this2.adInterval) {
            timeElapsed = 0;
            _this2.playMidrollAds();
          } else if (timeElapsed >= _this2.premiumTimeout) {
            _this2.setState({ showTimeout: true, isStreaming: false });
            _this2.camPlayer.stop();
            timeElapsed = 0;
          }
        });
      }
    }
  }, {
    key: 'playAd',
    value: function playAd() {
      if (this.props.isPersistentCam) {
        return;
      }
      var playerWidth = this.camPlayer.getWidth();
      var playerHeight = this.camPlayer.getHeight();
      var adTag = this.getAdTag(playerWidth, playerHeight);
      if (adTag) this.camPlayer.playAd(adTag);
    }

    // Midroll daisychain: 30-15-30

  }, {
    key: 'playMidrollAds',
    value: function playMidrollAds() {
      var _this3 = this;

      this.setState({ showUpSell: true, isStreaming: false });
      this.camPlayer.stop();

      setTimeout(function () {
        _this3.setState({ showUpSell: false, showTimeout: false });
        _this3.camPlayer.play();
      }, this.upsellDuration * 1000);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          nighttime = _props4.nighttime,
          rewindClip = _props4.rewindClip,
          adCountdown = _props4.adCountdown,
          camera = _props4.camera,
          playerId = _props4.playerId,
          spotId = _props4.spotId,
          adblock = _props4.adblock,
          legacySpotId = _props4.legacySpotId,
          onClickUpSell = _props4.onClickUpSell,
          onClickAdBlock = _props4.onClickAdBlock,
          onDetectedAdBlock = _props4.onDetectedAdBlock,
          funnelUrl = _props4.funnelUrl,
          rewindUrl = _props4.rewindUrl,
          camHostAd = _props4.camHostAd,
          isPremium = _props4.isPremium,
          spotName = _props4.spotName;
      var _state = this.state,
          showTimeout = _state.showTimeout,
          showUpSell = _state.showUpSell,
          isStreaming = _state.isStreaming,
          adCountdownTime = _state.adCountdownTime,
          networkError = _state.networkError;
      var status = camera.status;


      if (status.isDown || networkError.isDown) {
        return _react2.default.createElement(_CamError2.default, {
          message: status.isDown ? status.message : networkError.message,
          rewindUrl: legacySpotId && legacySpotId !== spotId ? rewindUrl : null
        });
      }

      if (adblock && onDetectedAdBlock) {
        return _react2.default.createElement(_CamAdBlock2.default, {
          href: funnelUrl,
          onClick: onClickAdBlock,
          onMount: onDetectedAdBlock,
          rewindUrl: legacySpotId && legacySpotId !== spotId ? rewindUrl : null
        });
      }

      if (nighttime && !rewindClip) {
        return _react2.default.createElement(_CamNighttime2.default, {
          stillUrl: camera.stillUrl,
          rewindUrl: legacySpotId && legacySpotId !== spotId ? rewindUrl : null,
          nighttime: nighttime
        });
      }

      return _react2.default.createElement(
        'div',
        { className: this.className() },
        adCountdown ? _react2.default.createElement(
          'div',
          { className: 'quiver-cam-player__countdown' },
          adCountdownTime ? _react2.default.createElement(
            'span',
            null,
            'This ad will end in ',
            adCountdownTime,
            ' seconds'
          ) : null
        ) : null,
        _react2.default.createElement(
          'div',
          { className: 'quiver-cam-player__player' },
          _react2.default.createElement(
            'div',
            {
              style: { display: isStreaming ? 'block' : 'none' },
              className: this.getHostedAdClassName()
            },
            camHostAd
          ),
          !nighttime && isStreaming && rewindUrl && legacySpotId && legacySpotId !== spotId ? _react2.default.createElement(_CamRewind2.default, {
            href: rewindUrl,
            isPremium: isPremium,
            legacySpotId: legacySpotId,
            spotId: spotId,
            spotName: spotName
          }) : null,
          nighttime && isStreaming && rewindUrl && legacySpotId && legacySpotId !== spotId ? _react2.default.createElement(_CamRewindMessage2.default, { href: rewindUrl }) : null,
          _react2.default.createElement(
            _AspectRatioContent2.default,
            null,
            showTimeout ? _react2.default.createElement(_CamTimeout2.default, {
              stillUrl: camera.stillUrl,
              onClick: this.resumePlayer
            }) : null,
            showUpSell ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_CamUpsell2.default, {
                href: funnelUrl,
                onClick: onClickUpSell,
                stillUrl: camera.stillUrl
              }),
              _react2.default.createElement(
                'div',
                { className: 'quiver-cam-player__upsell-countdown' },
                'Next ad will start in ',
                _react2.default.createElement(_CountDownTimer2.default, { countTime: this.upsellDuration }),
                ' seconds'
              )
            ) : null,
            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: '<div id="' + playerId + '"></div>' } })
          )
        )
      );
    }
  }]);
  return CamPlayer;
}(_react.Component);

CamPlayer.defaultProps = {
  nighttime: false,
  rewindClip: null,
  adCountdown: false,
  adUnitCode: null,
  companionHandler: null,
  aspectRatio: '16:9',
  onClickAdBlock: null,
  onClickUpSell: null,
  onDetectedAdBlock: null,
  onToggleStreaming: null,
  funnelUrl: null,
  advertisingIds: {
    spotId: null,
    subregionId: null
  },
  isPremium: true,
  isPersistentCam: false,
  adblock: false,
  rewindUrl: null,
  spotName: null,
  spotId: null,
  legacySpotId: null,
  viewType: null,
  adTag: null,
  camHostAd: _react2.default.createElement('div', null),
  qaFlag: null
};
CamPlayer.propTypes = {
  nighttime: _propTypes2.default.bool,
  rewindClip: _propTypes2.default.string,
  adCountdown: _propTypes2.default.bool,
  playerId: _propTypes2.default.string.isRequired,
  camera: _propTypes2.default.shape({
    streamUrl: _propTypes2.default.string,
    stillUrl: _propTypes2.default.string,
    status: _propTypes2.default.shape()
  }).isRequired,
  onDetectedAdBlock: _propTypes2.default.func,
  onToggleStreaming: _propTypes2.default.func,
  advertisingIds: _propTypes2.default.shape({
    spotId: _propTypes2.default.string,
    subregionId: _propTypes2.default.string
  }),
  adblock: _propTypes2.default.bool,
  spotName: _propTypes2.default.string,
  spotId: _propTypes2.default.string,
  legacySpotId: _propTypes2.default.string,
  rewindUrl: _propTypes2.default.string,
  isPremium: _propTypes2.default.bool,
  isPersistentCam: _propTypes2.default.bool,
  aspectRatio: _propTypes2.default.string,
  funnelUrl: _propTypes2.default.string,
  companionHandler: _propTypes2.default.func,
  onClickAdBlock: _propTypes2.default.func,
  onClickUpSell: _propTypes2.default.func,
  viewType: _propTypes2.default.string,
  adTag: _propTypes2.default.object,
  camHostAd: _propTypes2.default.node,
  qaFlag: _propTypes2.default.string
};
exports.default = CamPlayer;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamPlayer/CamPlayer.js
// module id = 538
// module chunks = 11